import React, { useState } from "react";
import ResponsiveWrapper from "../_responsive-wrapper";

const Tabs = ({ children }) => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <ResponsiveWrapper className="tabs">
            <div className="tabs__titles">
                {React.Children.map(children, (child, index) => (
                    // eslint-disable-next-line react/button-has-type
                    <button
                        onClick={() => setActiveTab(index)}
                        className={`tabs__titles-button ${activeTab === index ? "tabs__titles-button--active" : ""}`}
                    >
                        {child.props.title}
                    </button>
                ))}
            </div>
            <div className="tabs__content">
                {React.Children.map(children, (child, index) => (
                    <div className={`tabs__content-panel ${activeTab === index ? "tabs__content-panel--active" : ""}`}>
                        {child.props.children}
                    </div>
                ))}
            </div>
        </ResponsiveWrapper>
    );
};

export default Tabs;
